import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo/logo1.png'
import _imports_1 from '@/assets/images/logo/logo-dark.png'
import _imports_2 from '@/assets/images/login/icon.png'


const _hoisted_1 = { class: "container-fluid wizard-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3 col-md-4 position-relative bg-color" }
const _hoisted_4 = { class: "anchor" }
const _hoisted_5 = { class: "progresscont" }
const _hoisted_6 = { class: "circleblocks" }
const _hoisted_7 = { class: "user-profile" }
const _hoisted_8 = { class: "aboutblock" }
const _hoisted_9 = { class: "addressblock" }
const _hoisted_10 = { class: "verifyblock" }
const _hoisted_11 = { class: "col-lg-9 col-md-8 p-0" }
const _hoisted_12 = { class: "step-container login-card" }
const _hoisted_13 = { class: "login-main" }

import Swal from 'sweetalert2'
import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterWizard',
  setup(__props) {

const RegisterWizardData = defineAsyncComponent(() => import("@/components/theme/authantication/RegisterWizardData.vue"))
let active = ref<number>(1)
let checkedTab = ref<number[]>([])
let showToast = ref<boolean>(false)
function clickToNext() {
    if (active.value < 4) {
        active.value++
        checkedTab.value.push(active.value)
    }
}
function clickToPrevious() {
    if (active.value > 0) {
        active.value--
        checkedTab.value.splice(active.value, 1)
    }
}
function showNotify() {
    Swal.fire({
        text: 'Congratulation ! All step Done.',
        icon: 'success',
        showCloseButton: true,
        confirmButtonText: 'Ok',
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = '/authentication/register/wizard';
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: "logo text-start ps-0",
              to: "/"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  class: "img-fluid for-light m-auto",
                  src: _imports_0,
                  alt: "looginpage"
                }, null, -1),
                _createElementVNode("img", {
                  class: "img-fluid for-dark",
                  src: _imports_1,
                  alt: "logo"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "circulo activecirculo text-center" }, [
                      _createElementVNode("i", { class: "fas fa-user" })
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["user-content", _unref(checkedTab).includes(2) ? 'done' : ''])
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("h4", { class: "font-primary" }, "About", -1),
                      _createElementVNode("h6", null, "Add personal details", -1)
                    ]))], 2)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "circulo text-center" }, [
                      _createElementVNode("i", { class: "fas fa-location-arrow" })
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["user-content", _unref(checkedTab).includes(3) ? 'done' : ''])
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("h4", { class: "font-primary" }, "Address", -1),
                      _createElementVNode("h6", null, "Add additional info", -1)
                    ]))], 2)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "circulo text-center" }, [
                      _createElementVNode("i", { class: "far fa-id-card" })
                    ], -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["user-content", _unref(checkedTab).includes(4) ? 'done' : ''])
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("h4", { class: "font-primary" }, "Verify", -1),
                      _createElementVNode("h6", null, "Complete.. !", -1)
                    ]))], 2)
                  ])
                ])
              ])
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("li", null, [
            _createElementVNode("img", {
              class: "img-fluid w-100",
              src: _imports_2,
              alt: "looginpage"
            })
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "wizard-title text-center" }, [
              _createElementVNode("h2", null, "Sign up to account"),
              _createElementVNode("h5", { class: "text-muted mb-4" }, "Enter your email & password to login")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "progress",
                style: {"height":"5px"}
              }, [
                _createElementVNode("div", {
                  class: "progress-bar",
                  id: "progresswizard",
                  role: "progressbar",
                  style: {"width":"15%"},
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                })
              ], -1)),
              _createVNode(_unref(RegisterWizardData), {
                showToast: _unref(showToast),
                active: _unref(active),
                onFinish: showNotify,
                onNext: clickToNext,
                onPrev: clickToPrevious
              }, null, 8, ["showToast", "active"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})